/**
 * `cn()`: join class names and let the last Tailwind utility of a group win
 * (`cn('px-2', condition && 'px-4')` → `px-4`). shadcn/ui's helper, used by
 * every component so a caller's `className` can override a variant.
 */
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
